module.exports = __webpack_public_path__ + "static/media/LazyAz_web2.96b26eb4.jpg";